import {
  CoolblueEnergyChip,
  EducationChip,
  HoursChip,
  InternalChip,
  LocationChip,
  SalaryChip
} from '@components/Chips';
import { CbShadowSubtle } from '@coolblue-development/design-tokens';
import { ChipGroup } from '@coolblue-development/freddy';
import { type ChipUSPs as ChipUSPsType, ChipUSPsVariant } from '@sharedTypes';

import { LocationSelector } from './LocationSelector';
import { RelocationChipModal } from './RelocationChipModal';

type Props = {
  chipUSPs: ChipUSPsType;
};

export const ChipUSPs = ({ chipUSPs }: Props) => {
  const LocationVariant = () => {
    switch (chipUSPs.variant) {
      case ChipUSPsVariant.LocationSpecific:
        return <LocationChip locationValue={chipUSPs.location.displayName} />;
      case ChipUSPsVariant.Group:
        return <LocationSelector locations={chipUSPs.locations} />;
    }
  };

  return (
    <ChipGroup
      size={{ xs: 'small', md: 'medium' }}
      sx={{ '> span': { boxShadow: CbShadowSubtle } }}
    >
      {chipUSPs.isInternal && <InternalChip />}
      {chipUSPs.relocationPossible && <RelocationChipModal />}
      {LocationVariant()}
      {chipUSPs.hours && <HoursChip hours={chipUSPs.hours} />}
      <SalaryChip salaryValue={chipUSPs.salaryValue} salaryRange={chipUSPs.salaryRange} />
      <EducationChip educationLevels={chipUSPs.educationLevels} />
      {chipUSPs.isCoolblueEnergy && <CoolblueEnergyChip />}
    </ChipGroup>
  );
};
